import {
  ADD_PROVIDER_ROLES,
  SET_IS_LOADING_ROLES,
  SET_SELECTED_ROLE,
} from "../Actions/types";

const INITIAL_STATE = {
  isLoadingRoles: false,
  roles: [],
  selectedRole: null,
};

const supervisionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_IS_LOADING_ROLES:
      return {
        ...state,
        isLoadingRoles: action.payload,
      };

    case ADD_PROVIDER_ROLES:
      return {
        ...state,
        roles: action.payload,
        selectedRole: action.payload[0] || null,
      };

    case SET_SELECTED_ROLE:
      return {
        ...state,
        selectedRole: action.payload,
      };

    default:
      return state;
  }
};
export default supervisionReducer;
